<template>
  <div>
    <b-btn
      v-b-tooltip.hover
      variant="none"
      :title="`Empresas vinculadas (${empresasIds.length})`"
      class="btn btn-sm btn-none px-50 py-0"
      @click="show()"
    >
      <font-awesome-icon
        icon="fa-solid fa-building"
        :class="empresasIds.length > 0 ? 'text-success' : 'text-secondary'"
      />
      <b-badge
        v-if="empresasIds.length > 0"
        variant="success"
        class="ml-25"
        style="font-size: 10px;"
      >
        {{ empresasIds.length }}
      </b-badge>
    </b-btn>

    <b-modal
      ref="modalEmpresas"
      no-close-on-backdrop
      size="xl"
      @hidden="fechar"
    >
      <div slot="modal-title">
        <h5>Empresas - {{ tituloRotina }}</h5>
        <fieldset class="font-weight-bold text-muted">
          Selecione as empresas que receberão o envio automático desta rotina
        </fieldset>
      </div>

      <div
        v-if="carregando"
        class="text-center py-3"
      >
        <b-spinner small />
        Carregando...
      </div>

      <div v-else>
        <vinculo-empresas
          ref="vinculoEmpresas"
          v-model="empresasBase"
          :cadastro-usuario="true"
          :visualizacao-opcoes="visualizacaoOpcoes"
          :filtros-vinculadas="filtrosVinculadas"
          :filtros-nao-vinculadas="filtrosNaoVinculadas"
          :tem-busca="true"
        >
          <template #filtro-nao-vinculadas>
            <b-col
              cols="4"
              style="max-width: 100%;"
              class="d-flex align-items-center"
            >
              <v-select
                v-model="filtroCustomSelecionado"
                :options="filtrosCustom"
                label="nome"
                placeholder="Filtros"
                :clearable="true"
                multiple
                deselect-from-dropdown
                class="filtro-select-custom flex-grow-1 pr-1 mb-1"
                @input="aplicarFiltroCustom"
              >
                <template #selected-option="{ nome, cor }">
                  <b-badge
                    pill
                    :style="`background-color:${cor}; max-width:100px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; display:inline-block;`"
                  >
                    {{ nome }}
                  </b-badge>
                </template>
                <template #option="{ nome, cor }">
                  <b-badge
                    pill
                    :style="`background-color:${cor};`"
                  >
                    {{ nome }}
                  </b-badge>
                </template>
                <template slot="no-options">
                  <span>Nenhum filtro cadastrado</span>
                </template>
              </v-select>
              <div
                class="ml-50 mb-1 cursor-pointer"
                @click="abrirGerenciarFiltros"
              >
                <feather-icon
                  icon="EditIcon"
                  class="text-primary"
                  size="15"
                />
              </div>
            </b-col>
          </template>
        </vinculo-empresas>
      </div>

      <!-- FiltroCustom oculto — usado apenas para abrir o modal de gestão de filtros -->
      <div style="display:none;">
        <filtro-custom
          ref="filtroCustomModal"
          :api="apiFiltroCustom"
          :filtros-default-docs="filtrosDefaultDocs"
          @aplicarFiltro="onFiltroCustomAtualizado"
        />
      </div>

      <template #modal-footer>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-success btn-none mr-50"
          :disabled="salvando"
          @click="salvar"
        >
          <b-spinner
            v-if="salvando"
            small
            class="mr-25"
          />
          Salvar
        </b-btn>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-danger btn-none"
          @click="$refs.modalEmpresas.hide()"
        >
          Cancelar
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import filtroCustomApi from '@pilar/components/filtro-custom/filtroCustomApi'
import api from '../services/api'
import EventBus from '../../../shared/mixins/event-bus/eventBus'
import apiTermos from '../../../shared/services/api-termos'

const apiFiltroCustom = filtroCustomApi('envio_automatico')

const FILTROS_DEFAULT_DOCS = [
  'Todos',
  'CND RFB/PGFN',
  'CND FGTS',
  'CND Trabalhista',
  'CND Estadual',
  'CND Municipal',
]

export default {
  name: 'EmpresasEnvioAutomatico',
  components: {
    vSelect,
    VinculoEmpresas: () => import('@pilar/components/vinculo-empresas/VinculoEmpresas.vue'),
    FiltroCustom: () => import('@pilar/components/filtro-custom/FiltroCustom.vue'),
  },
  props: {
    tipoRotina: {
      type: Number,
      required: true,
    },
    tituloRotina: {
      type: String,
      required: true,
    },
    empresasIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      carregando: false,
      salvando: false,
      empresasBase: { vinculadas: [], naoVinculadas: [] },
      todasEmpresas: [],
      idsDoFiltroCustom: null,
      empresasIdsOriginal: [],
      filtroCustomSelecionado: [],
      filtrosCustom: [],
      filtrosDefaultDocs: FILTROS_DEFAULT_DOCS,
      filtrosVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosNaoVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      apiFiltroCustom,
    }
  },
  computed: {
    visualizacaoOpcoes() {
      return {
        customTitle: ' ',
        customSubtitle: ' ',
        placeholderBusca: 'Buscar por: CNPJ/CPF, razão social',
        tituloVinculada: 'Empresas vinculadas ao envio',
        tituloDesvinculada: 'Empresas Desvinculadas',
        evento: (_id, filtros) => {
          const { filtroBy, ordemBy } = filtros.filtro || {}
          const termoBruto = (filtroBy?.[0]?.valor || '').trim().toLowerCase()
          const termoSemMascara = termoBruto.replace(/[.\-/]/g, '')
          const vinculadasIds = new Set((filtros.idsVinculadas || []).map(Number))

          let resultado = filtros.isVinculada
            ? this.todasEmpresas.filter(e => vinculadasIds.has(this.empresaId(e)))
            : this.todasEmpresas.filter(e => !vinculadasIds.has(this.empresaId(e)))

          if (!filtros.isVinculada && this.idsDoFiltroCustom !== null) {
            resultado = resultado.filter(e => this.idsDoFiltroCustom.has(this.empresaId(e)))
          }

          if (termoBruto) {
            resultado = resultado.filter(e => {
              const cnpj = (e.cadastroFederal || '').toLowerCase()
              const cnpjSemMascara = cnpj.replace(/[.\-/]/g, '')
              const razao = (e.razaoSocial || '').toLowerCase()
              return cnpj.includes(termoBruto)
                || cnpjSemMascara.includes(termoSemMascara)
                || razao.includes(termoBruto)
            })
          }

          if (ordemBy?.length) {
            const { coluna, tipo } = ordemBy[0]
            resultado = [...resultado].sort((a, b) => {
              const va = (a[coluna] || '').toLowerCase()
              const vb = (b[coluna] || '').toLowerCase()
              return tipo === 'desc' ? vb.localeCompare(va) : va.localeCompare(vb)
            })
          }

          return Promise.resolve({ data: resultado })
        },
      }
    },
  },
  methods: {
    show() {
      apiTermos.getPendentes([2])
        .then(r => {
          if (r.data?.length) {
            EventBus.$emit('termosPendentes', r.data)
            EventBus.$once('termoAceito', () => this.abrirModal())
          } else {
            this.abrirModal()
          }
        })
        .catch(() => this.abrirModal())
    },
    abrirModal() {
      this.carregando = true
      this.$refs.modalEmpresas.show()
      this.empresasIdsOriginal = [...this.empresasIds]
      this.filtroCustomSelecionado = []

      Promise.all([
        api.getEmpresasParaVinculo(this.tipoRotina),
        apiFiltroCustom.getFiltroCustomResumido(),
      ])
        .then(([payloadEmpresas, payloadFiltros]) => {
          const todasEmpresas = payloadEmpresas.data
          const idsVinculados = new Set(this.empresasIds)

          this.todasEmpresas = todasEmpresas
          this.empresasBase = {
            vinculadas: todasEmpresas.filter(e => idsVinculados.has(e.empresaId || e.id)),
            naoVinculadas: todasEmpresas.filter(e => !idsVinculados.has(e.empresaId || e.id)),
          }
          this.filtrosCustom = payloadFiltros.data
        })
        .catch(() => {
          this.$erro('Não foi possível carregar as empresas.')
          this.$refs.modalEmpresas.hide()
        })
        .finally(() => {
          this.carregando = false
        })
    },

    empresaId(e) {
      return e.empresaId || e.id
    },

    aplicarFiltroCustom(filtros) {
      const idsVinculadosAtual = new Set(this.empresasBase.vinculadas.map(e => this.empresaId(e)))
      const naoVinculadasAtual = this.todasEmpresas.filter(e => !idsVinculadosAtual.has(this.empresaId(e)))

      if (!filtros || filtros.length === 0) {
        this.idsDoFiltroCustom = null
        this.empresasBase = { ...this.empresasBase, naoVinculadas: naoVinculadasAtual }
        this.$nextTick(() => this.$refs.vinculoEmpresas.buscar(false))
        return
      }

      Promise.all(filtros.map(f => apiFiltroCustom.getFiltroCustomById(f.id)))
        .then(resultados => {
          const idsDosFiltros = new Set(
            resultados.flatMap(r => (r.data.empresas?.vinculadas || []).map(e => this.empresaId(e))),
          )
          this.idsDoFiltroCustom = idsDosFiltros
          this.empresasBase = {
            ...this.empresasBase,
            naoVinculadas: naoVinculadasAtual.filter(e => idsDosFiltros.has(this.empresaId(e))),
          }
          this.$nextTick(() => this.$refs.vinculoEmpresas.buscar(false))
        })
        .catch(() => {
          this.$erro('Não foi possível carregar as empresas do filtro.')
        })
    },

    abrirGerenciarFiltros() {
      this.$refs.filtroCustomModal.show()
    },

    onFiltroCustomAtualizado() {
      apiFiltroCustom.getFiltroCustomResumido()
        .then(payload => {
          this.filtrosCustom = payload.data
          if (this.filtroCustomSelecionado) {
            const atualizado = payload.data.find(f => f.id === this.filtroCustomSelecionado.id)
            this.filtroCustomSelecionado = atualizado || null
            this.aplicarFiltroCustom(this.filtroCustomSelecionado)
          }
        })
    },

    salvar() {
      if (this.salvando) return
      this.salvando = true

      const novasIds = this.empresasBase.vinculadas.map(e => this.empresaId(e))

      api.salvarEmpresas(this.tipoRotina, novasIds)
        .then(() => {
          this.$emit('atualizar', { tipoRotina: this.tipoRotina, empresasIds: novasIds })
          this.$refs.modalEmpresas.hide()
          this.$sucesso('Empresas atualizadas com sucesso')
        })
        .catch(() => {
          this.$erro('Não foi possível salvar as empresas.')
        })
        .finally(() => {
          this.salvando = false
        })
    },

    fechar() {
      this.empresasBase = { vinculadas: [], naoVinculadas: [] }
      this.todasEmpresas = []
      this.idsDoFiltroCustom = null
      this.filtroCustomSelecionado = []
      this.salvando = false
    },
  },
}
</script>

<style lang="scss">
.filtro-select-custom {
  .vs__dropdown-toggle {
    max-height: 38px;
    overflow: hidden;
  }
  .vs__selected-options {
    flex-wrap: nowrap;
    overflow: hidden;
    max-height: 34px;
  }
  .vs__selected {
    background-color: #f0f0f0 !important;
    border: none !important;
    overflow: hidden;
    white-space: nowrap;
    max-width: 120px;
    text-overflow: ellipsis;
  }
}
</style>
